// extracted by mini-css-extract-plugin
module.exports = {"close":"close___1G8vs"};